import { Edit, Trash2 } from 'lucide-react'
import type { JSX } from 'react/jsx-runtime'

import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
  TruncatedText,
} from '@/components/ui'
import { HighlightText } from '@/components/ui/table/DataTable/HighlightText'
import type { CellContext } from '@/components/ui/table/types'
import type { Transaction } from '@/modules/projects'
import {
  DeleteTransactionsDialog,
  EditTransactionDialog,
} from '@/modules/projects/components'
import { getDialogActions } from '@/stores/dialog'

export const ContextMenuCell = <T extends string | number>(
  Cell?: (cell: CellContext<Transaction, T>) => JSX.Element,
) => {
  const { openDialog } = getDialogActions()

  return (cell: CellContext<Transaction, T>) => {
    const transaction = cell.row.original as Transaction
    const searchQuery = cell.table.options.meta?.searchQuery
    const noun =
      transaction?.typename === 'CheckRecord' ? 'Check' : 'Transaction'

    const value = Cell ? (
      Cell(cell)
    ) : (
      <HighlightText text={String(cell.getValue() ?? '')} query={searchQuery} />
    )

    return (
      <ContextMenu>
        <ContextMenuTrigger asChild>
          <div className="h-full w-full flex items-center cursor-context-menu min-w-0">
            <TruncatedText
              className="w-full"
              text={String(cell.getValue() ?? '')}
            >
              {value}
            </TruncatedText>
          </div>
        </ContextMenuTrigger>
        <ContextMenuContent>
          <ContextMenuItem
            onClick={() => openDialog(EditTransactionDialog.id, transaction)}
          >
            <Edit className="h-4 w-4" />
            Edit {noun}
          </ContextMenuItem>
          <ContextMenuSeparator />
          <ContextMenuItem
            onClick={() =>
              openDialog(DeleteTransactionsDialog.id, [transaction])
            }
            destructive
          >
            <Trash2 className="h-4 w-4" />
            Delete {noun}
          </ContextMenuItem>
        </ContextMenuContent>
      </ContextMenu>
    )
  }
}
